<canvas class="cool-background-canvas" ref="coolCanvas"></canvas>